import { useContext, useState, useEffect } from 'react';
import PaymentOptions from './PaymentOptions';
import { CheckoutContext } from './CheckoutContext';
import { numberFormat, showToast } from '../../../Utils';

import { getListPaymentMethod, checkoutBooking } from '../../../api/ServiceAPI';

function CheckoutPayment() {
  const {data, updateData} = useContext(CheckoutContext);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [submited, setSubmited] = useState(false);
  
  useEffect(() => {
    const onSuccessHandler = (responseJSON) => setPaymentMethods(responseJSON);
    const onFailureHandler = (messages) => console.debug("FAIL", messages);
    let total = data.package.price * data.schedules.time.length;
    if (data.payment.isDP) {
      total = data.payment.DP;
    }

    getListPaymentMethod(total, onSuccessHandler, onFailureHandler);
  }, [])

  if (submited) {
    window.location = data.paymentMethod.payment_url;
    return null; 
  }

  const handleChangePaymentMethod = (selected) => {
    data.paymentMethod = selected;
    updateData(data);
  }

  let subtotal = data.package.price * data.schedules.time.length;
  let totalAddon = 0;
  data.addons.forEach((addon) => {
    totalAddon += (addon.price * addon.qty);
  });
  subtotal += totalAddon;

  let DP = data.payment.isDP ? data.payment.DP : 0;
  let total = subtotal - DP;

  const validate = () => {
    if (data.paymentMethod.pg_code === undefined)
      return {valid: false, msg: "Silahkan pilih metode pembayaran"}

    return {valid: true, msg: "OK"};
  }

  const onSubmit = () => {
    let {valid, msg} = validate();

    if (valid) {
      const onSuccessHandler = (responseJSON) => {
        data.paymentMethod.payment_url = responseJSON.payment_url;
        updateData(data);
        setSubmited(true);
      }
      const onFailureHandler = (messages) => showToast("Error", "Fail", msg);
      
      checkoutBooking(data, onSuccessHandler, onFailureHandler)
    } else {
      showToast("Error", "Alert", msg);
    }
  }

  return (
    <div className='md:flex md:gap-x-8 pt-12'>

      <div className='md:w-7/12'>
        <p className='text-md font-semibold mb-4'>Konfirmasi Pesanan</p>
        <div className='px-6 py-6 flex flex-col gap-y-8 border border-gray-300 rounded-xl mb-8'>

          <table className='table-auto '>
            <tbody>

              <tr>
                <td>
                  <p className='text-sm font-semibold text-gray-500'>Paket</p>
                </td>
              </tr>

              <tr>
                <td>
                  <p className='text-sm font-semibold text-gray-800'>
                    {data.package.name} ({data.package.description}) {data.schedules.time.length} Sesi
                  </p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>Rp.</p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>
                    {numberFormat(data.package.price * data.schedules.time.length, false)}
                  </p>
                </td>
              </tr>

              <tr >
                <td className='pt-6'>
                  <p className='text-sm font-semibold text-gray-500'>Add On</p>
                </td>
              </tr>

              {(data.addons.length > 0) ? data.addons.map((addon) => (
                  <tr key={addon.id}>
                    <td className='pt-2'>
                      <p className='text-sm font-semibold text-gray-800'>{addon.name} {addon.qty} {addon.unit}</p>
                    </td>
                    <td>
                      <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>Rp.</p>
                    </td>
                    <td >
                      <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>{numberFormat(addon.price * addon.qty, false)}</p>
                    </td>
                  </tr>
                )) : (
                <tr>
                  <td className='pt-2'>
                    <p className='text-sm font-semibold text-gray-800'>-</p>
                  </td>
                  <td colSpan={2}>
                    &nbsp;
                  </td>
                </tr>
              )}

              <tr className='border-b border-gray-300'>
                <td className='pt-6 pb-6'>
                  <p className='text-sm font-semibold text-gray-500'>Biaya Aplikasi</p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>Rp.</p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>0</p>
                </td>
              </tr>
              <tr>
                <td className='pt-4'>

                </td>
              </tr>
              <tr className=''>
                <td className='py-2'>
                  <p className='text-sm text-right pr-6 font-semibold text-gray-500'>Sub Total</p>
                </td>
                <td className=''>
                  <p className='text-sm items-center justify-end flex font-semibold text-gray-700'>Rp.</p>
                </td>
                <td>
                  <p className='text-sm items-center justify-end flex font-semibold text-gray-700'>
                    {numberFormat(subtotal, false)}
                  </p>
                </td>
              </tr>

              <tr className=''>
                <td className='py-2'>
                  <p className='text-sm text-right pr-6 font-semibold text-gray-500'>Uang Muka</p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>Rp.</p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>
                    {numberFormat(DP, false)}
                  </p>
                </td>
              </tr>

              <tr className=''>
                <td className='py-2'>
                  <p className='text-sm text-right pr-6 font-semibold text-gray-500'>Sisa Bayar</p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>Rp.</p>
                </td>
                <td>
                  <p className='text-sm items-end justify-end flex font-semibold text-gray-700'>
                    {numberFormat(total, false)}
                  </p>
                </td>
              </tr>


            </tbody>
          </table>

        </div>

        <div className='bg-[#F5F5F5] rounded-2xl p-8 flex flex-col mb-8'>
          <p className='text-md font-semibold mb-4'>Kebijakan Booking Lapang</p>
          <div className='flex w-full items-start'>
            <ul className='list-[square] ml-5'>
              <li>
                <p className='text-gray-700 text-xs tracking-wide leading-loose mb-4'>
                  Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet.
                  Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui.
                  Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero,
                  sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar,
                  hendrerit id, lorem.
                </p>
              </li>
            </ul>
          </div>
        </div>

      </div>

      <div className='md:w-5/12'>
        <p className='text-md font-semibold '>Pilih Metode Pembayaran</p>

        <div className='flex flex-col gap-y-2'>
          <PaymentOptions 
            plan={paymentMethods} 
            onChange={handleChangePaymentMethod} 
            readonly={submited} />
        </div>

        <div>
          {(!submited) && (
            <button className='w-full bg-primaryRed text-white rounded-lg px-10 py-3 text-sm font-semibold mt-4' onClick={ e => onSubmit() }>
              Lanjut Pembayaran
            </button>
          )}
        </div>

      </div>

    </div>
  );
}

export default CheckoutPayment;